import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-pros',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-pros.component.html',
  styleUrl: './offer-pros.component.css',
})
export class OfferProsComponent {
  header = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  bold3 = input<string>();
  text3 = input<string>();
  bold4 = input<string>();
  text4 = input<string>();
}
